import { ThemeEvents } from '@theme/events';

class FFNVariantDetails extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const section = this.closest('.shopify-section');
    section?.addEventListener(ThemeEvents.variantUpdate, this.#updateDetails, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #updateDetails = (event) => {
    const detail = event.detail;
    if (String(detail?.data?.productId) !== this.dataset.productId) return;

    const source = detail.data.html?.getElementById(this.id);
    if (!source) return;

    if (!detail.resource?.id) {
      this.replaceChildren();
      this.dataset.hasContent = 'false';
      this.dataset.variantId = '';
      return;
    }

    this.replaceChildren(...source.cloneNode(true).childNodes);
    this.dataset.hasContent = source.dataset.hasContent;
    this.dataset.variantId = String(detail.resource.id);
  };
}

if (!customElements.get('ffn-variant-details')) {
  customElements.define('ffn-variant-details', FFNVariantDetails);
}
